export default {"src":"/_next/static/media/logo-letter.5963ab78.svg","height":23,"width":71,"blurWidth":0,"blurHeight":0};